import { Box, Text } from '@bechtel/gds';
import { AppSpinner } from '~/components';
//@ts-ignore images ignore
import SetRouteLogoText from '~/images/setroute-logo-text.svg';
//@ts-ignore images ignore
import SetRouteLogo from '~/images/setroute-logo.svg';
import { LoaderBoxStyled, TradeMarkWrapper } from './styled';

export const AuthLoader = () => {
  return (
    <LoaderBoxStyled>
      <Box justifyContent={{ sm: 'center' }} alignItems={{ sm: 'center' }} flexGrow={{ sm: 1 }}>
        <Box flexDirection={{ sm: 'column' }}>
          <Box style={{ width: 'auto' }} flexDirection={{ sm: 'column' }} alignItems={{ sm: 'center' }}>
            <img src={SetRouteLogo} style={{ width: '145px' }} />
            <img src={SetRouteLogoText} style={{ width: '200px' }} />
          </Box>
          <Box justifyContent={{ sm: 'flex-end' }} mt={{ sm: '400' }} pb={{ sm: '900' }}>
            <Text size="500" color="primary.700" family="openSans">
              v10.0
            </Text>
          </Box>
          <Box
            justifyContent={{ sm: 'center' }}
            pt={{ sm: '900' }}
            mt={{ sm: '600' }}
            alignItems={{ sm: 'center' }}
            css={`
              ${({ theme }) => `border-top: 1px solid ${theme.colors.grey[200]};`}
            `}
          >
            <AppSpinner />
            <Box ml={{ sm: '400' }}>
              <Text size="450" family="openSans">
                Authorizing…
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
      <TradeMarkWrapper>
        <Box pr={{ sm: '500' }}>
          <Text family="openSans" size="200">
            SETROUTE and the SETROUTE logo are registered trademarks of Bechtel Corporation.
          </Text>
        </Box>
        <Box flexShrink={{ sm: 0 }}>
          <Text family="openSans" size="200">
            © {new Date().getFullYear()} Bechtel Corporation. All Rights Reserved.
          </Text>
        </Box>
      </TradeMarkWrapper>
    </LoaderBoxStyled>
  );
};
